export const emailCitaConfirmada = (data) => {
  const maviInstructions = data.empresa_id === 2 ? `
    <hr />
    <p><strong>Aviso Importante Mavi Farmacéutica:</strong></p>
    <p style="text-align: justify; font-size: 14px; color: #333;">
      Agradeceré nos apoyen con el uso correcto de su Equipo de Protección Personal ya que de no contar con sus guantes y chaleco color naranja (no malla), nos veremos en la necesidad de cancelar el recibo y esperar una nueva cita. No olviden que su transporte contratado y/o propio deberá presentar la APP con su licencia digital; si presenta constancia impresa deberá ser legible, actualizada y que el código se pueda escanear para verificar sus datos.
    </p>
    <p style="text-align: justify; font-size: 14px; color: #333;">
      En resumen, para el recibo ya al haber ingresado al almacén nave 2 cortina 61 de Macrocentro se requiere presentar lo siguiente:
    </p>
    <ul style="font-size: 14px; color: #333;">
      <li>Factura</li>
      <li>Orden Compra</li>
      <li>Certificado de Calidad</li>
      <li>Certificado de fumigación de la unidad que se descargará actualizado.</li>
    </ul>
    <p style="font-size: 14px; color: #333;"><strong>Para personal que realizará la descarga:</strong></p>
    <ul style="font-size: 14px; color: #333;">
      <li>Chaleco de tela (no malla) color naranja</li>
      <li>Guantes</li>
      <li>Zapato de seguridad con casquillo en bota</li>
      <li>Pantalón de mezclilla (no roto).</li>
      <li>No usar playeras sin mangas.</li>
    </ul>
    <hr />
  ` : '';

  return `
    <p>Has recibido un nuevo mensaje autom&aacute;tico de Sanfer.</p>
    <p>La cita ha sido confirmada con los siguientes datos:</p>
    <ul>
      <li>📅 <strong>Fecha:</strong> ${data.fecha}</li>
      <li>🕒 <strong>Hora inicio:</strong> ${data.horaIni}</li>
      <li>🕓 <strong>Hora fin:</strong> ${data.horaFin}</li>
      <li>⏱️ <strong>Duración:</strong> ${data.duracion}</li>
      <li>🏢 <strong>Almacén:</strong> ${data.nombreAlmacen}</li>
      <li>📍 <strong>Dirección:</strong> ${data.direccion}</li>
      <li>🔗 <strong>Mapa:</strong> <a href="${data.mapaURL}" target="_blank">${data.mapaURL}</a></li>
    </ul>
    <p>
      Para revisar la información completa de la reservación, consulta:<br>
      <a href="${data.urlApi}/reservacion/${data.folio}">
        ${data.urlApi}/reservacion/${data.folio}
      </a>
    </p>
    ${maviInstructions}
    <p>Gracias.<br>Equipo Sanfer.</p>
  `;
};